<template>
  <div>
    <div v-show="showView" class="fixed-header" mg-stat-mod="back">
      <button class="back-padding-top-new" @click="goBack">
        <i v-if="hasGoBack" class="icon go_back"></i>
      </button>
      <section class="fixed-header__title">{{ title }}</section>
      <section class="fixed-header__edit">
        <span v-if="isEdit" @click="edit">{{ editTitle }}</span>
        <i
            v-if="isShowIcon"
            class="icon share"
            @click="isShowSelfShare = true"
        ></i>
        <div
            v-if="showRule"
            class="rule"
            @click="edit">
          <i class="icon help"></i>
          <span>使用规则</span>
        </div>
      </section>
    </div>
    <mt-popup v-model="isShowSelfShare" position="bottom">
      <share-modal :shareContent="shareContent"></share-modal>
    </mt-popup>
  </div>
</template>
<script>
import MgtvApi from 'MgtvApi';
import Env from 'utils/env';
import ShareModal from 'components/common/ShareModal';

export default {
  props: [
    'editTitle',
    'title',
    'shareContent',
    'notShowBack',
    'targetUrl',
    'hidden',
    'showRule',
  ],
  components: { ShareModal },
  data() {
    return {
      isShowSelfShare: false, // 自定义UI的分享
      isShowIcon: false,
    };
  },
  computed: {
    hasGoBack() {
      return !this.notShowBack;
    },
    isEdit() {
      return !!this.editTitle;
    },
    WebviewTitle() {
      return this.title ? this.title : '芒果好物';
    },
    showView() {
      if (
        this.$router.currentRoute.name !== 'cart' &&
          // this.$router.currentRoute.name !== 'coupon' &&
          (Env.isWeixin || Env.isWeiBo || Env.isQQ || Env.isMgtvApp)
      ) {
        return false;
      }
      return !this.hidden;
    },
  },
  created() {
    document.title = this.WebviewTitle;
    MgtvApi.setWebviewTitle({ title: this.WebviewTitle });
  },
  watch: {
    shareContent: {
      handler(val) {
        if (val && Env.isMgtvApp) {
          MgtvApi.callhandler('isHalfWebview', {}, (returnVal) => {
            let isHalf = returnVal;
            if (Env.isAndroid) {
              const { data } = JSON.parse(returnVal);
              isHalf = Number(data);
            }
            if (isHalf) {
              // 半屏用自定义UI分享
              this.isShowIcon = true;
            } else {
              // 如果是全屏 则调用端上的分享
              this.isShowIcon = false;
              this.shareInApp();
            }
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    shareInApp() {
      const {
        shareContent: { shareDesc: desc, ...other },
      } = this;
      MgtvApi.showShareMenus({
        desc,
        ...other,
      });
    },
    edit() {
      this.$emit('edit');
    },
    showShareModal() {
      this.isShowSelfShare = true;
    },
    goBack() {
      try {
        if (this.targetUrl) {
          this.$router.push({ path: this.targetUrl });
          return;
        }
        if (this.hasGoBack) {
          window.history.go(-1);
        }
      } catch (error) {
        this.$message(error.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back-padding-top-new {
  /*2020年4月23 替换返回按键 重新调整padding top*/
  padding-top: 18px !important;
}

.fixed-header {
  @media screen and (min-width: 1025px) {
    width: 500px; /*no*/
    left: calc(50% - 250px); /*no*/
    right: calc(50% - 250px); /*no*/
    padding: 0;
  }
  position: fixed;
  z-index: 3000;
  background: #fff;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 30px;
  display: flex;
  justify-content: space-around;

  section,
  button {
    flex: 1;
    height: 86px;
    padding-top: 12px;
    box-sizing: border-box;
    line-height: 86px;
  }

  button {
    text-align: left;
    padding-top: 15px;
  }

  &__title {
    font-size: 28px;
    color: #000;
    text-align: center;
  }

  &__edit {
    font-size: 30px;
    color: #9b9b9b;
    text-align: right;

    .rule {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      span {
        font-size: 22px;
        color: #ff5f00;
        margin-left: 8px;
      }
    }
  }
}
</style>
